export const FLEX_DEMO_PATH = "/flex-demo";

export const FLEX_DEMO_STEPS = [
  "explore",
  "preview",
  "express-interest",
  "auto-accept",
  "pay",
  "workspace",
  "finish",
] as const;

export type FlexDemoStep = (typeof FLEX_DEMO_STEPS)[number];

export const FLEX_DEMO_STEP_LABELS: Record<FlexDemoStep, string> = {
  explore: "Explore",
  preview: "Partner profile",
  "express-interest": "Express interest",
  "auto-accept": "Partner accepts",
  pay: "Unlock workspace",
  workspace: "Workspace & report",
  finish: "Finish",
};

export function flexDemoSessionStorageKey(userId: string): string {
  return `gt:flexDemo:${userId}`;
}
